import Vue from "vue";

const state = {
	blockedTemplate: '',
	meetingTemplate: '',
	noMeetingTemplate: '',
	sessionTemplate: '',
	transportTemplate: '',
	welcomeTemplate: ''
};

const getters = {
	blockedTemplate (state) {
		return state.blockedTemplate;
	},
	meetingTemplate (state) {
		return state.meetingTemplate;
	},
	noMeetingTemplate (state) {
		return state.noMeetingTemplate;
	},
	sessionTemplate (state) {
		return state.sessionTemplate;
	},
	transportTemplate (state) {
		return state.transportTemplate;
	},
	welcomeTemplate (state) {
		return state.welcomeTemplate;
	}
};

const actions = {

};

const mutations = {

};

export default {
	state,
	getters,
	actions,
	mutations
}